import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToPageTarget } from '../utils/scrollToPageTarget';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.querySelectorAll('[data-page-scroll]').forEach(element => {
      element.scrollTop = 0;
    });
  }, [pathname]);

  useEffect(() => {
    let observer;
    let observerTimeout;
    const scrollToHash = () => {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); }
      catch { return; }
      if (!id) return;
      const target = document.getElementById(id);
      if (target) {
        observer?.disconnect();
        scrollToPageTarget(target);
      } else if (!observer) {
        observer = new MutationObserver(scrollToHash);
        observer.observe(document.body, { childList: true, subtree: true });
        observerTimeout = window.setTimeout(() => observer.disconnect(), 5000);
      }
    };
    const frame = requestAnimationFrame(scrollToHash);
    window.addEventListener('hashchange', scrollToHash);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('hashchange', scrollToHash);
      observer?.disconnect();
      window.clearTimeout(observerTimeout);
    };
  }, [pathname, hash]);

  return null;
}
